import React, {useEffect, useRef} from "react";
import {Tabs} from "components/common";
import type {TabsProps} from "antd";
import ListPharmacy from "./components/ListPharmacy/ListPharmacy";
import Import from "./components/Import/Import";
import {tabKeys} from "types/enums";
import Catalog from "./components/Catalog/Catalog";
import Detail from "./components/Detail/Detail";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import Reserve from "./components/Reserve/Reserve";
import Export from "./components/Export/Export";
import Inventory from "./components/Inventory/Inventory";
import InventoryDetail from "./components/InventoryDetail/InventoryDetail";
import Report from "./components/Report/Report";
import {setSiderKey} from "redux/reducer/common";
import BID_DEADLINE from "./components/BidDeadline/BidDeadline";
import BidDeadline from "./components/BidDeadline/BidDeadline";

const PharmacyStore = () => {
  document.title = "Kho dược";
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector(state => state.common.activeTab);
  const detailRef = useRef<any>();
  const items: TabsProps["items"] = [
    {
      key: tabKeys.PHARMACY_STORE.LIST_PHARMACY,
      label: `Kho dược`,
      children: <ListPharmacy />,
    },
    {
      key: tabKeys.PHARMACY_STORE.IMPORT,
      label: `Phiếu nhập`,
      children: <Import></Import>,
    },
    {
      key: tabKeys.PHARMACY_STORE.EXPORT,
      label: `Phiếu xuất`,
      children: <Export></Export>,
    },
    {
      key: tabKeys.PHARMACY_STORE.RESERVE,
      label: `Phiếu dự trù`,
      children: <Reserve></Reserve>,
    },
    {
      key: tabKeys.PHARMACY_STORE.DETAIL,
      label: "Chi tiết phiếu",
      children: <Detail ref={detailRef}></Detail>,
    },
    // {
    //   key: tabKeys.PHARMACY_STORE.ALLOCATION,
    //   label: `Cấp phát thuốc`,
    //   children: <Allocation></Allocation>,
    // },
    {
      key: tabKeys.PHARMACY_STORE.INVENTORY,
      label: `Phiếu kiểm kê`,
      children: <Inventory></Inventory>,
    },

    {
      key: tabKeys.PHARMACY_STORE.INVENTORY_DETAIL,
      label: `Chi tiết kiểm kê`,
      children: <InventoryDetail></InventoryDetail>,
    },
    {
      key: tabKeys.PHARMACY_STORE.REPORT,
      label: `Báo cáo nâng cao`,
      children: <Report></Report>,
    },
    {
      key: tabKeys.PHARMACY_STORE.BID_DEADLINE,
      label: "Xem hạn thầu",
      children: <BidDeadline></BidDeadline>,
    },
    {
      key: tabKeys.PHARMACY_STORE.CATALOG,
      label: "Cấu hình hệ thống",
      children: <Catalog></Catalog>,
    },
  ];
  useEffect(() => {
    // dispatch(setDetailRef(detailRef));
  }, [detailRef]);

  useEffect(() => {
    dispatch(setSiderKey("khoDuoc"));
  }, []);

  return (
    <div className="medicine-store page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default PharmacyStore;
